import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-table-content-empty',
  templateUrl: './table-content-empty.component.html',
  styleUrls: ['./table-content-empty.component.scss'],
})
export class TableContentEmptyComponent {
  @Input()
  isLoading = false;
  @Input()
  isError = false;

  reload() {
    window.location.reload();
  }
}
